
define('ldsh!common/templates/404', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="404__page error__page md__general__content__empty margin-auto">\n  <div>\n    <img\n      alt="404"\n      src="https://static.test.mdirector.com/assets/themes/v3/globals/src/images/assets/error-picture.svg"\n    />\n  </div>\n  <h2 class="i18n mt16" data-i18n="pageListing.notFound.title"></h2>\n  <h3 class="i18n" data-i18n="pageListing.notFound.description"></h3>\n  <p class="i18n" data-i18n="[html]pageListing.notFound.instructions"></p>\n  <div class="ed-404-actions">\n    <a class="ed-btn ed-btn-sec" data-i18n="pageListing.notFound.link" href="/pages"></a>\n  </div>\n</div>\n';

}
return __p
};});

